import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material'
import { useTheme } from '../contexts/ThemeContext'
import {
  MODAL_PAPER_STYLES,
  MODAL_TITLE_STYLES,
  MODAL_CONTENT_STYLES,
  MODAL_BUTTON_STYLES,
} from './shared/modalStyles'

interface ConfirmModalProps {
  open: boolean
  title: string
  message: string
  onConfirm: () => void
  onCancel: () => void
  confirmText?: string
  cancelText?: string
}

export default function ConfirmModal({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Yes',
  cancelText = 'No',
}: ConfirmModalProps) {
  const { colors } = useTheme()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          ...MODAL_PAPER_STYLES,
          backgroundColor: colors.background,
          border: `2px solid ${colors.primary}`,
          boxShadow: `0 0 20px ${colors.primaryShadow}`,
        },
      }}
    >
      <DialogTitle
        sx={{
          ...MODAL_TITLE_STYLES,
          color: colors.primary,
          textShadow: `0 0 10px ${colors.primaryShadow}`,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ ...MODAL_CONTENT_STYLES, color: colors.text }}>
          {message}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onCancel}
          sx={{
            ...MODAL_BUTTON_STYLES,
            color: colors.primary,
            borderColor: colors.primary,
            border: '1px solid',
            '&:hover': {
              backgroundColor: colors.primary,
              color: colors.background,
            },
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            ...MODAL_BUTTON_STYLES,
            backgroundColor: colors.primary,
            color: colors.background,
            '&:hover': {
              backgroundColor: colors.primary,
              opacity: 0.9,
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
